import base from './base'

let controller = 'Appraisal'
let action = null

const Appraisal = {
  async listQuestion (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListAppraisalQuestions'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addAppraisalQuestion (request) {
    action = 'AddAppraisalQuestion'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async editAppraisalQuestion (request) {
    if (!request.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `EditAppraisalQuestion`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async deleteAppraisalQuestion (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `DeleteAppraisalQuestion/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getAppraisalQuestion (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `GetAppraisalQuestion/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async listSection (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListAppraisalSections'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addAppraisalSection (request) {
    action = 'AddAppraisalSection'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async editAppraisalSection (request) {
    if (!request.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `EditAppraisalSection`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async deleteAppraisalSection (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `DeleteAppraisalSection/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getAppraisalSection (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `GetAppraisalSection/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addQuestionsToSection (request) {
    action = `AddQuestionsToSection`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async removeQuestionsFromSection (request) {
    action = `RemoveQuestionsFromSection`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async moveQuestionRank (request) {
    action = `MoveQuestionRank`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async listPaper (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListAppraisalPapers'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addAppraisalPaper (request) {
    action = 'AddAppraisalPaper'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async editAppraisalPaper (request) {
    if (!request.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `EditAppraisalPaper`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async deleteAppraisalPaper (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `DeleteAppraisalPaper/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getAppraisalPaper (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `GetAppraisalPaper/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addSectionsToPaper (request) {
    action = `AddSectionsToPaper`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async removeSectionsFromPaper (request) {
    action = `RemoveSectionsFromPaper`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async moveSectionRank (request) {
    action = `MoveSectionRank`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async listRecord (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListAppraisalRecords'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async assignAppraisalPaper (request) {
    action = `AssignAppraisalPaper`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async submitAppraisalPaper (request) {
    action = `SubmitAppraisalPaper`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditAppraisalPaper (request) {
    action = `AuditAppraisalPaper`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async getAppraisalRecord (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `GetAppraisalRecord/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async deleteAppraisalRecord (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `DeleteAppraisalRecord/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },
}

export default Appraisal